<template>
    <div class="card">
      <div class="card-body">
        <AjaxForm v-if="!error && brand" :route="'productBrand/Edit/'+brand._id">
        <div class="row">
          <div class="col-md-6">
            <CustomInput name="title" v-model="brand.title" placeholder="عنوان را وارد کنید" type="text" label="عنوان"></CustomInput>
          </div>
          <div class="col-md-6">
            <CustomInput name="en_title" v-model="brand.en_title" placeholder="عنوان انگلیسی را وارد کنید" type="text" label="عنوان انگلیسی"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput :select_multiple="true" placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_ids[]" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         v-model="guild"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="کشور را انتخاب کنید" label="کشور برند" name="country_id" select-label="name" :select-options="country_options"
                         :fetch-options="getCountryForSelect"
                         v-model="country"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-md-6">
            <CustomInput name="description" v-model="brand.description" placeholder="توضیحات را وارد کنید" type="textarea" label="توضیحات برند"></CustomInput>
          </div>
          <div class="col-md-3 d-flex">
            <label class="mr-4">تصویر</label>
            <ImagePicker :file_id="(brand.pic_id?brand.pic_id:null)" :file_url="(brand.pic_url?brand.pic_url:null)" name="pic_id"></ImagePicker>
          </div>
          <div class="col-md-3 d-flex">
            <label class="mr-4">تصویر</label>
            <ImagePicker :file_id="(brand.box_pic_id?brand.box_pic_id:null)" :file_url="(brand.box_pic_url?brand.box_pic_url:null)" name="box_pic_id"></ImagePicker>
          </div>
        </div>
          <div class="row">
            <div class="col-8 col-sm-8 col-md-5 mx-auto mt-2">
              <button class="btn btn-info btn-block" type="submit">ویرایش اطلاعات برند</button>
            </div>
          </div>
        </AjaxForm>
        <div class="alert alert-danger" v-else>
          {{error}}
        </div>
      </div>

    </div>
</template>

<script>
import vSelect from 'vue-select'
import MasterLayout from "@/components/MasterLayout";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import Loading from "@/components/Loading";
import {mapActions} from "vuex";
import ImagePicker from "@/components/ImagePicker";
import {ProductApi} from "@/api/ProductApi";
import {AppApi} from "@/api/AppApi";
export default {
  name: "EditProductBrand",
  components: {ImagePicker, Loading, AjaxForm, CustomInput, MasterLayout,vSelect},
  data(){
    return {
      prefix:process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
      brand : null,
      error : null,
      id : this.$route.params.id,
      select_guild_option : [],
      guild : null,
      country_options:[],
      country : null,
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش اطلاعات برند محصول');
    this.setShowHead(true);
    this.initPage();
  },
  methods : {
    ...mapActions('app',{
      getProductBrand : 'getProductBrand'
    }),
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      const id = this.$route.params.id;
      const result = await this.getProductBrand(id);
      if (result)
      {
        if (result.ok)
        {
          this.brand = result.brand;
          this.country = result.country;
          this.guild = result.guilds;
        }
        else
        {
          this.error = result.error;
        }
      }
      else
      {
        this.brand = null;
        this.error = 'خطای سرور...';
      }
      this.setPageLoading(false);
    },
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
    async getCountryForSelect(search,loading)
    {
      loading(true);
      if (search.length)
      {
        const data = await AppApi.getCountryForSelectAjax(search);
        if (data.ok)
        {
          this.country_options = data.countries;
        }
        else
          this.country_options = [];
      }
      loading(false);
    },
  }

}
</script>

<style scoped>

</style>
